<nav class="help-sidebar">
  <ul class="nav flex-column p-0">
    <li class="nav-item">
      <div class="nav-link f-s-14"
           routerLink="copyright"
           routerLinkActive="active-link"
           (click)="closeAllMenus()">
        Copyright
      </div>
    </li>

    <li class="nav-item">
      <div class="nav-link f-s-14"
           routerLink="licence"
           routerLinkActive="active-link"
           (click)="closeAllMenus()">
        Licence
      </div>
    </li>

    <li class="nav-item">
      <div class="nav-link f-s-14"
           routerLink="introduction"
           routerLinkActive="active-link"
           (click)="closeAllMenus()">

        Introduction

      </div>
    </li>


    <li class="nav-item">
      <div class="nav-link f-s-14"
           routerLink="Quickreference"
           routerLinkActive="active-link"
           (click)="closeAllMenus()">

        Quick Reference

      </div>
    </li>


    <li class="nav-item">

      <div class="nav-link f-s-14"
           routerLink="Charities"
           routerLinkActive="active-link"
           (click)="closeAllMenus()">

        Charities

      </div>

    </li>



    <!--Accounting period-->
    <li class="nav-item">

      <div class="nav-link f-s-14"
           routerLink="accounting-period"
           routerLinkActive="active-link"
           (click)="closeAllMenus()">

        Accounting Period

      </div>

    </li>

    <li class="nav-item">

      <div class="nav-link f-s-14"
           routerLink="submissionhistorysdata"
           routerLinkActive="active-link"
           (click)="closeAllMenus()">

        Submission History

      </div>

    </li>

    <li class="nav-item">

      <div class="nav-link f-s-14"
           routerLink="reportsguidedataset"
           routerLinkActive="active-link"
           (click)="closeAllMenus()">

        Reports

      </div>

    </li>



    <!--Settings-->
    <li class="nav-item">

      <div class="nav-link f-s-14"
           routerLink="settingshelp"
           routerLinkActive="active-link"
           (click)="closeAllMenus()">

        Settings

      </div>

    </li>
  </ul>
</nav>
